import React from "react";
import SignUpSignIn from "./SignUpSignIn";
import Navbar from "./Navbar";
import Footer from "./Footer";
import '../Styles/AccountTypeSelection.scss';
import {Helmet} from "react-helmet";

function AccountTypeSelection() {
   return (
      <div className="AccountTypeSelectionRoot">
         <SignUpSignIn/>
      </div>
   )
};

export default AccountTypeSelection;
